import React from 'react'

import { serviceOrdersClient } from '../../../../utils/apollo/api'
import CleanFilterButton from '../../../../components/filter/CleanFilterButton'
import FlexGrid, { FlexColumn } from '../../../../components/structure/FlexGrid'
import ListCounter from '../../../../components/helpers/ListCounter'
import SeparatorWrapper from '../../../../components/helpers/SeparatorWrapper'

const ServiceOrdersCounterBar = () => {
  return (
    <SeparatorWrapper weight={4}>
      <FlexGrid>
        <FlexColumn flex={1}>
          <ListCounter
            client={serviceOrdersClient}
            entity="serviceOrders"
            filterName="ServiceOrderFilter"
            fullText
            bold
          />
        </FlexColumn>
        <FlexColumn>
          <CleanFilterButton />
        </FlexColumn>
      </FlexGrid>
    </SeparatorWrapper>
  )
}

export default ServiceOrdersCounterBar
